import { User } from "./types";

export const LOGIN_ACTION = "login";
export const LOGOUT_ACTION = "logout";
export const WHITELIST_USER_ACTION = "whitelistUser";
export const REGISTER_USER_DETAILS_ACTION = "registerUserDetails";

interface LoginAction {
  type: typeof LOGIN_ACTION;
  payload: {
    token: string;
  };
}

interface LogoutAction {
  type: typeof LOGOUT_ACTION;
}

interface WhitelistCurrentUser {
  type: typeof WHITELIST_USER_ACTION;
  payload: boolean;
}

interface RegisterUserDetails {
  type: typeof REGISTER_USER_DETAILS_ACTION;
  payload: User;
}

export type Action =
  | LoginAction
  | LogoutAction
  | WhitelistCurrentUser
  | RegisterUserDetails;
